export default "__VITE_ASSET__BsE9eIGs__"